import { useContext, useEffect, useState } from "react";
import {
  Button, FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextareaAutosize,
  TextField
} from "@mui/material";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import Loader from "../../component/Loader";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import userImg from '../../assets/images/user.png';
import ReCAPTCHA from "react-google-recaptcha";
import { AuthAPI } from "../../api/AuthAPI";
import { UserAPI } from "../../api/UserAPI";
import 'react-phone-input-2/lib/material.css';
import { GameAPI } from "../../api/GameAPI";
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { rootAction } from "../../redux/reducer/rootReducer";


const validatorObj = Yup.object({
  organizationName: Yup.string().max(100, "must not exceed 100 characters").required("Organization name is required"),
  firstName: Yup.string().max(100, "must not exceed 100 characters").required("First name is required"),
  lastName: Yup.string().max(100, "must not exceed 100 characters").required("Organization name is required"),
  email: Yup.string().max(100, "must not exceed 100 characters").required("Email is required"),
  //phone: Yup.string().max(100, "must not exceed 100 characters").required("Phone is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8)
    .matches(/[A-Z]/, { excludeEmptyString: true })
    .matches(/[0-9]/, { excludeEmptyString: true })
    .matches(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@$*])[A-Za-z0-9!@$*]{8,20}$/, { excludeEmptyString: true })
  ,
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Password must match"),
 // dob: Yup.string().required("Date of birth is required"),
  game: Yup.string().required("Game is required"),
  //address: Yup.string().max(100, "must not exceed 100 characters").required("Address is required"),
  description: Yup.string().max(1000, "must not exceed 1000 characters").required("Description is required"),
})

const ClubRegister = () => {
  document.title = "Club Registration"
  const navigate = useNavigate();
  const { setIsLoading, isLoading } = useContext(AuthContext);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [registerData, setRegisterData] = useState({});
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [isPhoneInputFocused, setIsPhoneInputFocused] = useState(false);
  const [passwordValidate, setPasswordValidate] = useState({ length: false, specialSymbal: false, allowedChars:false, number: false, upperLetter: false, lowerLetter:false })
  const [gameNames, setGameNames] = useState([]);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const handleClickShowPassword = () => setShowPassword1((show) => !show);
  const handleClickShowConfirmPassword = () => setShowPassword2((show) => !show);

  const getAllGameNames = async () => {
    try {
      const response = await GameAPI.getGamesByPlatform();
      setGameNames(response);
    } catch (error) {

    }
  }

  useEffect(() => {
    if (gameNames.length < 1) {
      getAllGameNames();
    }
  }, [])
  const passwordValidator = (event) => {
    const { name, value } = event.target;
    const uppercasePattern = /[A-Z]/;
    const lowercasePattern = /[a-z]/;
    const numberPattern    = /[0-9]/;
    // Exactly one of ! @ $ *
    const specialCharPattern = /[!@$*]/; 
    const allowedCharsPattern = /^[A-Za-z0-9!@$*]+$/;

    let template = {}
    if (uppercasePattern.test(value)) {
      template.upperLetter = true;
    }
    if (lowercasePattern.test(value)) {
      template.lowerLetter = true;
    }
    if (specialCharPattern.test(value)) {
      template.specialSymbal = true;
    }
    if (allowedCharsPattern.test(value)) {
      template.allowedChars = true;
    }
    if (numberPattern.test(value)) {
      template.number = true;
    }
    if (value?.length >= 8 && value?.length <= 20) {
      template.length = true;
    }
    setPasswordValidate(template);

  };

  const handleRegistrationData = (event) => {
    Object.keys(errors).length != 0 && setErrors({});
    const { name, value } = event.target;
    if (name === 'password') {
      passwordValidator(event);
    }
     let newVal;
    // if (name === 'phone' && !value.startsWith('1')) {
    //   newVal = '1' + value
    // } else {
    //   newVal = value;
    // }
    newVal = value;
    setRegisterData(prev => ({ ...prev, [name]: newVal }));
  };

  const submitRegisterData = async (event) => {
    try {
      event.preventDefault();
      await validatorObj.validate(registerData, { abortEarly: false });
      const clubRegistrationData = {
        username: registerData.email?.trim(),
        email: registerData.email?.trim(),
        password: registerData.password?.trim(),
        //dob: registerData.dob,
        //address: registerData.address?.trim(),
       // mobile: "+" + registerData.phone,
        firstName: registerData.firstName?.trim(),
        lastName: registerData.lastName?.trim(),
        club: { clubName: registerData.organizationName?.trim(), clubDescription: registerData.description?.trim() },
        isClubOwner: true,
        isCoach: false,
        isGuardian: false,
        isGuest: false,
        isPlayer: false,
        gameId: registerData.game,
        pathName: window.location.pathname
      };

      setIsLoading(true);
      await UserAPI.registerUser(clubRegistrationData);
      navigate("/email-sent", {
        replace: true,
        state: { userName: registerData.email, registerFor: 'club' },
      });
      setIsLoading(false);
    } catch (err) {
      if (err.inner) {
        let errObj = {};
        err.inner.forEach(e => {
          errObj[e.path] = e.message
        });
        setErrors(errObj);
      } else {
        dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: err?.response?.data?.Message }))
        console.error(err);
      }

    } finally {
      setIsLoading(false);
    }


  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
  const verifyCaptcha = async (data) => {
    try {
      const response = await AuthAPI.postVerifyCaptcha(data);
      setCaptchaVerified(response.Data);
    } catch (error) {

    }
  }

  return (
    <div className="player_register_container" onSubmit={submitRegisterData}>
      {isLoading && <Loader />}
      <form className="player_register_container_body">
        <div className="player_heading">
          <img src={userImg} alt="" />
          <h2>Club Registration</h2>
        </div>
        <TextField
          inputProps={{ maxLength: 100 }}
          error={errors['organizationName']}
          helperText={errors['organizationName'] && errors['organizationName']}
          value={registerData.organizationName || ""}
          onChange={handleRegistrationData}
          name="organizationName"
          className="player-reg-text-input"
          label="Organization Name"
          variant="outlined"
        />
        <div className="player_name">
          <TextField
            inputProps={{ maxLength: 100 }}
            error={errors['firstName']}
            helperText={errors['firstName'] && errors['firstName']}
            value={registerData.firstName || ""}
            onChange={handleRegistrationData}
            name="firstName"
            className="player-reg-text-input"
            sx={{ width: "49%", "@media (max-width:400px)": { width: "100%" } }}
            label="First Name"
            variant="outlined"
          />

          <TextField
            inputProps={{ maxLength: 100 }}
            error={errors['lastName']}
            helperText={errors['lastName'] && errors['lastName']}
            value={registerData.lastName || ""}
            onChange={handleRegistrationData}
            name="lastName"
            className="player-reg-text-input"
            sx={{ width: "49%", "@media (max-width:400px)": { width: "100%" } }}
            label="Last Name"
            variant="outlined"
          />
        </div>
        <TextField
          inputProps={{ maxLength: 100 }}
          error={errors['email']}
          helperText={errors['email'] && errors['email']}
          value={registerData.email || ""}
          onChange={handleRegistrationData}
          name="email"
          className="player-reg-text-input"
          type="email"
          label="Email"
          variant="outlined"
        />

        {/* <PhoneInput
          country={'us'}
          containerStyle={isPhoneInputFocused ?
            errors['phone'] ?
              {
                color: '#d32f2f'
              }
              :
              { color: 'var(--hoverColorBold)' }
            :
            errors['phone'] ?
              {
                color: '#d32f2f'
              } : { color: 'black' }}
          inputStyle={isPhoneInputFocused ?
            errors['phone'] ?
              {
                border: '1px solid #d32f2f',
                boxShadow: 'none',
                width: '100%',
                color: '#d32f2f',
                borderRadius: '10px',
              } :
              {
                border: '2px solid var(--hoverColorBold)',
                boxShadow: 'none',
                transition: '.2s ease',
                borderRadius: '10px',
                width: '100%'
              } : errors['phone'] ?
              {
                border: '1px solid #d32f2f',
                boxShadow: 'none',
                width: '100%',
                color: '#d32f2f',
                borderRadius: '10px',
              } : { borderRadius: '10px', width: '100%' }}
          disableDropdown={true}
          value={registerData.phone || ''}
          onFocus={() => setIsPhoneInputFocused(true)}
          onBlur={() => setIsPhoneInputFocused(false)}
          onChange={(e) => handleRegistrationData({ target: { name: 'phone', value: e } })}
        />
        {errors['phone'] && <div className="phone-number-input-error-msg">{errors['phone']}</div>} */}

        <FormControl
          fullWidth
          error={errors['password'] || errors.passwordValidateError}
          className="signup-text-input"
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-password">
            Password
          </InputLabel>
          <OutlinedInput
            value={registerData.password || ""}
            onChange={handleRegistrationData}
            name="password"
            sx={{ borderRadius: 2 }}
            id="outlined-adornment-password"
            type={showPassword1 ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword1 ? <MdVisibilityOff /> : <MdVisibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        <div className="password_validate_message_box">
          <p className={passwordValidate.upperLetter ?
            "password_validate_message active" :
            (errors['password']) ? "password_validate_message error" : "password_validate_message"}>

            <IoMdCheckmarkCircleOutline className="password_validate_log" />
            Require at least 1 Uppercase.
          </p>
          <p className={passwordValidate.lowerLetter ?
            "password_validate_message active" :
            (errors['password']) ? "password_validate_message error" : "password_validate_message"}>

            <IoMdCheckmarkCircleOutline className="password_validate_log" />
            Require at least 1 lowercase.
          </p>
          <p className={passwordValidate.specialSymbal ?
            "password_validate_message active" :
            (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
            <IoMdCheckmarkCircleOutline className="password_validate_log" />
            Must include exactly one of: ! @ $ * (no other special characters).
          </p>
          <p className={passwordValidate.allowedChars ?
            "password_validate_message active" :
            (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
            <IoMdCheckmarkCircleOutline className="password_validate_log" />
            No other characters allowed.
          </p>
          <p className={passwordValidate.number ?
            "password_validate_message active" :
            (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
            <IoMdCheckmarkCircleOutline className="password_validate_log" />
            Require at least 1 Number.
          </p>
          <p className={passwordValidate.length ?
            "password_validate_message active" :
            (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
            <IoMdCheckmarkCircleOutline className="password_validate_log" />
            Minimum 8 and Maximum 20 characters.
          </p>
          
        </div>
        <FormControl
          fullWidth
          className="signup-text-input"
          error={errors['confirmPassword'] || errors.passwordValidateError}
          variant="outlined"
        >
          <InputLabel htmlFor="outlined-adornment-password2">
            Confirm Password
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: 2 }}
            value={registerData.confirmPassword || ""}
            onChange={handleRegistrationData}
            name="confirmPassword"
            id="outlined-adornment-password2"
            type={showPassword2 ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirmPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword2 ? <MdVisibilityOff /> : <MdVisibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Confirm Password"
          />
          {errors['confirmPassword'] && (
            <FormHelperText sx={{ color: "red" }}>
              {errors['confirmPassword']}
            </FormHelperText>
          )}
        </FormControl>
        <div className="registation_date_and_game">
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              className="date_picker"
              value={registerData.dob}
              onChange={(e) => handleRegistrationData({ target: { name: 'dob', value: e } })}
              label="Date of Birth"
              slotProps={
                errors['dob'] && {
                  textField: {
                    color: "secondary",
                    error: "true",
                    helperText: "Select your date of birth",
                  },
                }
              }
              sx={{ width: "100%" }}
            />
          </LocalizationProvider> */}
          <FormControl sx={{ width: '100%' }}
            className="signup-text-input"
            error={errors['game']}
          >

            <InputLabel id="demo-multiple-chip-label">Game</InputLabel>
            <Select
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              value={registerData.game || ''}
              onChange={handleRegistrationData}
              label='Game'
              name="game"
            >
              {gameNames?.map((name) => (
                <MenuItem
                  key={name.gameId}
                  value={name.gameId}
                >
                  {name.gameName}
                </MenuItem>
              ))}
            </Select>
            {errors['game'] && (
              <FormHelperText sx={{ color: "red" }}>
                {errors['game']}
              </FormHelperText>
            )}
          </FormControl>
        </div>
        {/* <CustomPlaceAutocomplete
          onChange={(val) => {
            handleRegistrationData({ target: { name: 'address', value: val } })
          }}
          error={errors['address']}
          helperText={errors['address'] && errors['address']}
          value={registerData?.address || ''}
          variant="outlined"
          label="Address" /> */}
        <FormControl>
          <TextareaAutosize
            minRows={4}
            maxLength={1000}
            name="description"
            value={registerData.description || ""}
            onChange={handleRegistrationData}
            placeholder="Description"
            className={
              errors.description
                ? "club-register-textarea error"
                : "club-register-textarea"
            }
          />
          {errors['description'] && (
            <FormHelperText sx={{ color: "red" }}>
              {errors['description']}
            </FormHelperText>
          )}
        </FormControl>
        <ReCAPTCHA
          style={{ marginTop: '20px' }}
          sitekey={import.meta.env.VITE_APP_CAPTCHA_SITE_KEY}
          onChange={(data) => verifyCaptcha(data)}
        />
        <div className="player_reg_btn">
          <Button disabled={!captchaVerified} type="submit" variant="contained">
            Free trial(30 days)
          </Button>
        </div>
        <div className="club_privacy_policy">
          <p>By signing up, you agree to the Sportmingle <Link to={'https://sportmingle.com/terms_and_conditions.html'}>Term of Services</Link> and <Link to={'https://sportmingle.com/privacy_policy.html'}>Privacy Policy</Link></p>
        </div>
        <div className="redirect_to_sign_in">
          Already have an account?<Link to={'/login'}>Sign in</Link>
        </div>
      </form>
    </div>
  );
};

export default ClubRegister;